import React from 'react';

import useStyles from './signOutPendingStyles';

const SignOutPending: React.FC = () => {
  const classes = useStyles();

  return (
    <p role="status" className={classes.root}>
      You&apos;ve been signed out. This window will sign out when the call ends.
    </p>
  );
};

export default SignOutPending;
